import React, { useEffect, useState } from 'react'

const SHORTCUTS = [
  { key: 'Space', desc: 'Advance to next action / next hand' },
  { key: 'N', desc: 'Next action (same as Space during replay)' },
  { key: 'S', desc: 'Skip to showdown' },
  { key: '?', desc: 'Toggle this help overlay' },
  { key: '← → ↑ ↓', desc: 'Navigate matrix cells' },
  { key: 'Enter', desc: 'Toggle focused matrix cell' },
  { key: 'X', desc: 'Remove focused matrix cell' },
]

export function KeyboardHelp() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement)?.tagName
      if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') return
      if (e.key === '?') {
        e.preventDefault()
        setOpen(v => !v)
      } else if (e.key === 'Escape' && open) {
        setOpen(false)
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [open])

  if (!open) return null

  return (
    <div className="kb-help-overlay" onClick={() => setOpen(false)}>
      <div className="kb-help-panel" onClick={e => e.stopPropagation()}>
        <div className="kb-help-header">
          <h3>Keyboard Shortcuts</h3>
          <button className="kb-help-close" onClick={() => setOpen(false)}>×</button>
        </div>
        <div className="kb-help-list">
          {SHORTCUTS.map(s => (
            <div key={s.key} className="kb-help-row">
              <kbd className="kb-help-key">{s.key}</kbd>
              <span className="kb-help-desc">{s.desc}</span>
            </div>
          ))}
        </div>
        <div className="kb-help-footer">
          Press <kbd className="kb-help-key">?</kbd> or <kbd className="kb-help-key">Esc</kbd> to close
        </div>
      </div>
    </div>
  )
}
